<ion-item lines="none">
  <span [innerHTML]="label" style="font-weight: bold" *ngIf="label"></span>&nbsp;
  <markdown [class.overflowing]="isOverflowing" #markdownEl [data]="data" *ngIf="data" (swipe)="handleSwipe()" (ready)="checkOverflowing()" (scroll)="hideScrollArrow()"></markdown>
  <ion-icon class="overflow-indicator aniHoverX" name="chevron-forward-sharp" *ngIf="showOverflowArrow"></ion-icon>
</ion-item>